import { useTranslation } from "react-i18next";
import { Button, Dropdown, Form, Layout, MenuProps, Modal, Popconfirm, Space, Switch, TableColumnsType, TableProps, Tag, Typography, message } from "antd";
import { ChangeEvent, KeyboardEvent, useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom";
import { HelpService } from "../../../service/helper.service";
import { CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined, LoadingOutlined, MoreOutlined, SaveOutlined } from "@ant-design/icons";
import { FormInstance } from "antd/lib";
import { routesConfig } from "../../../config/routes";
import { DataType, validateFieldCreate } from "./constants/data";
import PageHeader from "../../../components/page-header/PageHeader";
import FilterTable from "./components/filter-table/FilterTable";
import FormFilter from "./components/filter-group/FormFilter";
import TableData from "../../../components/table-data/TableData";
import DrawerCustom from "../../../components/drawer/Drawer";
import FormCreateLecturer from "./components/form-create-lecturer/FormCreateLecturer";
import "./lecturer-management.scss"
import { formatDateV2 } from "../../../utils/converDate";
import { get, isEmpty } from "lodash";
import { addMoocLecturer, changeStatusLecturer, deleteMoocLecturer, downloadLecturerTemplateFile, exportExcelMoocLecturer, getAcademicLevelLecturer, getAddressProvinces, getAllLecturerByFilter, getIndustryGroupLecturer, getIndustryLecturer, getMoocEnterpriseUniversity, getMoocLecturerById, getPositionsLecturer, importExcelMoocLecturer, updateMoocLecturer } from "../../../service/category-management/lecturer-management";
import ImportIndustryDBModal from "./components/import-industry-db-modal/ImportIndustryDBModal";
import { getAllEnterpriseUniversityVer2 } from "../../../service/management-participate-platform";
import { getAllIndustryGroup } from "../../../service/course-construct";
import { globalStore } from "../../../stores/stores";
import { Permission } from "../../../layout/sidebar/permission.enum";

type LecturerManagementProps = {
  title?: string;
};

const LecturerManagement = ({ title }: LecturerManagementProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const helpService = new HelpService();
  const { personalInfo, reload } = globalStore();
  const permissions = personalInfo?.permissions;
  const [params, setParams] = useSearchParams();
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [isOpenedEdit, setIsOpenedEdit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingForm, setLoadingForm] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isRendering, setIsRendering] = useState<boolean>(false);
  const [hasUniversity, setHasUniversity] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [openImportLecturerModal, setOpenImportLecturerModal] = useState<boolean>(false);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [editId, setEditId] = useState<number>(0);
  const [dataDetail, setDataDetail] = useState<any>({});
  const [dataLecturer, setDataLecturer] = useState<any>([]);
  const [dataOptions, setDataOptions] = useState<any>({
    dataUniversity: [],
    dataAcademicLevel: [],
    dataRegency: [],
    dataProvinces: [],
    dataDepartment: [],
    dataSpecialized: [],
  });

  const [filterData, setFilterData] = useState<any>({
    keyword: null,
    status: null,
    university: null,
    regency: null,
    createdDateFrom: null,
    createdDateTo: null,
  });

  const lecturersOptions: MenuProps["items"] = [
    {
      key: "1",
      label: t("Sửa giảng viên", "Sửa giảng viên"),
      icon: <EditOutlined />,
    },
    {
      key: "2",
      label: t("Xóa giảng viên", "Xóa giảng viên"),
      icon: <DeleteOutlined />,
      className: "dropdown-delete",
      danger: true,
    },
  ];

  const dataColumns: TableColumnsType<DataType> = [
    {
      title: t("STT", "STT"),
      dataIndex: "stt",
      key: "stt",
      width: 10,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên giảng viên", "Tên giảng viên"),
      dataIndex: "name",
      key: "name",
      className:"title-sequence",
      sorter: true,
      width: 30,
      render: (_: any, record) => {
        return (
          <div className="table-lecturer cursor-pointer">
            <div>
              <a
                className="lecturer-name"
                onClick={() =>
                  navigate(
                    `${routesConfig.lecturerManagementDetail}/${record?.id}`,
                    {
                      state: {
                        mode: "view",
                        record,
                        name: record.name,
                      },
                    }
                  )
                }
              >
                {record.name}
              </a>
            </div>
          </div>
        );
      },
    },
    {
      title: t("Mã giảng viên", "Mã giảng viên"),
      dataIndex: "code",
      key: "code",
      className:"title-sequence",
      width: 20,
    },
    {
      title: t("Đơn vị công tác", "Đơn vị công tác"),
      dataIndex: "universityName",
      key: "universityName",
      className:"title-sequence",
      width: 40,
    },
    {
      title: t("Chức vụ", "Chức vụ"),
      dataIndex: "authPositions",
      key: "authPositions",
      className:"title-sequence",
      width: 30,
      render: (authPositions) => {
        return (
          <div>
            {authPositions.map((position: any) => (
              <Tag style={{ marginBottom: 5 }} key={position.name}>{position.name}</Tag>
            ))}
          </div>
        );
      }
    },
    {
      title: t("Email", "Email"),
      dataIndex: "email",
      key: "email",
      className:"title-sequence",
      width: 30,
    },
    {
      title: t("Ngày tạo", "Ngày tạo"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 20,
      render: (_: any, record: any, index: number) => {
        return record.createdDate ? formatDateV2(record.createdDate) : null;
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "status",
      key: "status",
      render: (_: any, record: { status: boolean; id: number }) => {
        const handleChange = (checked: boolean) => {
          record.status = checked;
        };

        const confirm = (id: number) => {
          setLoading(true);
          changeStatusLecturer({
            usedId: id,
            isActive: record?.status,
          }).then((res) => {
            if (res.status === 200) {
              setTimeout(() => {
                setLoading(false);
              }, 333);
              helpService.successMessage(t("Thay đổi trạng thái thành công!", "Thay đổi trạng thái thành công!"));
              getAllLecturer();
            }
          }).catch(err => {
            setLoading(false);
            console.error(err);
          })
        };

        const cancel = () => {
          helpService.errorMessage(t("Hủy thao tác thành công!", "Hủy thao tác thành công!"));
        };

        return (
          <Popconfirm
            rootClassName="popconfirm-change-status"
            description={t("Xác nhận đổi trạng thái?", "Xác nhận đổi trạng thái?")}
            onConfirm={() => confirm(get(record, 'id'))}
            onCancel={cancel}
            okText={t("Xác nhận", "Xác nhận")}
            cancelText={t("Huỷ", "Huỷ")}
            title="">
            <Switch defaultChecked={record.status}
              checked={record.status}
              onChange={handleChange} />
          </Popconfirm>
        );
      },
      width: 20,
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record.id}`,
        };

        return (
          <>
            <Space>
              <a
                className="action-table"
                onClick={() =>
                  navigate(
                    `${routesConfig.lecturerManagementDetail}/${record?.id}`,
                    {
                      state: {
                        mode: "view",
                        record,
                        name: record.name,
                        idEdit: record?.id,
                      },
                    }
                  )
                }
              >
                <EyeOutlined />
              </a>

              <Dropdown
                menu={{
                  items: lecturersOptions,
                  onClick: ({ key }) => {
                    if (key === "1") {
                      getLecturerUpdate(record.id);
                      handleOpenEdit(record.id);
                    }
                    if (key === "2") {
                      Modal.confirm({
                        title: t("Xóa giảng viên", "Xóa giảng viên"),
                        content: t("Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?", "Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?"),
                        onOk: () => deleteLecturer(record),
                        centered: true,
                        okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                      });
                    }
                  },
                }}
                placement="bottomRight"
              >
                <Button>
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space>
          </>
        );
      },
      fixed: "right",
      width: 20,
    },
  ];

  const listBreadcrumb = [
    {
      title: t("Quản trị danh mục", "Quản trị danh mục"),
    },
  ];

  // Get data lecturer
  const getAllLecturer = (data?: any) => {
    setLoading(true);
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      status: filterData.status,
      universityId: dataOptions.dataUniversity?.length === 1 ? dataOptions.dataUniversity?.[0]?.id : filterData.university,
      positionId: filterData.regency,
      createdFromDate: filterData.createdDateFrom ? filterData.createdDateFrom : null,
      createdToDate: filterData.createdDateTo ? filterData.createdDateTo : null,
      sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? ['created_date, desc'] : [`${fieldSortOrder},${statusOrder}`]
    };
    getAllLecturerByFilter(dataReq)
      .then((res) => {
        setDataLecturer(res.data.data.moocUniversityMemberData);
        setTotalRecords(res.data.data.total);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };
  
  // Filter Search
  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const check = !!(permissions?.includes(Permission.isQTCS) || permissions?.includes(Permission.isQTDH) || localStorage.schoolManagement);
  
  const clearFilter = (form: FormInstance) => {   
    const allFields = form.getFieldsValue();
    const fieldsToReset = Object.keys(allFields).filter((key) => key !== "university");
    check ? form.resetFields(fieldsToReset) : form.resetFields(); 
    
    setFilterData({
      university: check ? filterData.university : null,
      regency: null,
      createdDateFrom: null,
      createdDateTo: null,
      status: null,
    });
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setParams({ [name]: value });
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
      setParams();
    }
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      setPageNumber(1);
      getAllLecturer();
    }
  };

  const handleSubmitSearch = () => {
    setPageNumber(1);
    getAllLecturer();
  };

  const handleFinish = (values: any) => {
    setPageNumber(1);
    setFilterData({
      ...filterData,
      status: values?.status,
      university: values?.university,
      regency: values?.regency,
      createdDateFrom: values?.time ? (values?.time[0]).add(1, "day").toISOString() : null,
      createdDateTo: values?.time ? (values?.time[1]).add(1, "day").toISOString() : null,
    });
  };

  // Get university
  const getAllUniversity = async () => {
    setLoading(true);
    await getAllEnterpriseUniversityVer2({}).then((res) => {
      const dataEnterpriseUniversity = res.data?.data?.map((item: any) => {
        return ({
          id: item.universityId,
          name: item.name,
          uuid: item.uuid,
        })
      });

      setDataOptions({
        ...dataOptions,
        dataUniversity: dataEnterpriseUniversity,
      });

      setTimeout(() => {
        setLoading(false);
      }, 300);
    })
  }

  // Get lecturer to edit
  const getLecturerUpdate = async (id: number) => {
    setLoadingForm(true);
    await getMoocLecturerById(id).then((res) => {
      const { data } = res.data;
      setDataDetail(data);
      setTimeout(() => {
        setLoadingForm(false);
      }, 333);
    })
      .catch((err) => {
        setLoadingForm(false);
        console.error(err);
      });
  };

  // Modal create | edit
  const handleOpenCreate = () => {
    setIsOpened(true);
  };

  const handleOpenEdit = (id: number) => {
    setEditId(id);
    setIsOpened(true);
    setIsOpenedEdit(true);
  };

  const handleClose = () => {
    setIsOpened(false);
    setIsOpenedEdit(false);
    form.resetFields();
  };

  const handleCreateAndEdit = () => {
    Modal.confirm({
      title: !isOpenedEdit ? t("Thêm mới giảng viên", "Thêm mới giảng viên") : t("Chỉnh sửa giảng viên", "Chỉnh sửa giảng viên"),
      content: t("Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu", "Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu"),
      onOk: () => form.submit(),
      centered: true,
      okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn />
        </>
      ),
    });
  }

  const onFinishCreate = async (values: any) => {
    if (Object.keys(values).length > 0) {
      if (isOpenedEdit) {
        const dataPayload = {
          name: values.name.trim(),
          universityId: values.university,
          gender: values.gender,
          code: values.code ? values.code.trim() : null,
          provinceCode: values.domicile ? values.domicile : null,
          positionIds: values.regency ? [values.regency] : null,
          educationLevels: values.academicLevel ? [values.academicLevel] : null,
          industryGroupId: values.department ? values.department : null,
          industryIds: values.specialized ? values.specialized : null,
          phoneNumber: values.phone ? values.phone.trim() : null,
          email: values.email.trim(),
          status: values.status,
        };
        setIsSaving(true);
        try {
          await updateMoocLecturer(editId, dataPayload).then((res) => {
            const { success } = res.data;
            if (success) {
              message.success(t("Cập nhật giảng viên thành công!", "Cập nhật giảng viên thành công!"));
            } else {
              message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
            }
            handleClose();
            getAllLecturer();
          })
        } catch (err) {
          console.error(err);
        } finally {
          setIsSaving(false);
        }
      } else {
        const dataPayload = {
          name: values.name.trim(),
          universityId: values.university,
          gender: values.gender,
          code: values.code ? values.code.trim() : null,
          provinceCode: values.domicile ? values.domicile : null,
          positionIds: values.regency ? [values.regency] : null,
          educationLevels: values.academicLevel ? [values.academicLevel] : null,
          industryGroupId: values.department ? values.department : null,
          industryIds: values.specialized ? values.specialized : null,
          phoneNumber: values.phone ? values.phone.trim() : null,
          email: values.email.trim(),
          status: values.status,
        };
        
        setIsSaving(true);
        try {
          await addMoocLecturer(dataPayload).then((res) => {
            const { success } = res.data;
            if (success) {
              message.success(t("Thêm mới giảng viên thành công!", "Thêm mới giảng viên thành công!"));
            } else {
              message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
            }
            handleClose();
            getAllLecturer();
          })
        } catch (err) {
          console.error(err);
        } finally {
          setIsSaving(false);
        }
      }
    }
  };

  // Delete lecturer
  const deleteLecturer = async (lecturer: any) => {
    try {
      await deleteMoocLecturer(lecturer.id).then((res) => {
        if (res.status === 200) {
          message.success(t("Xóa giảng viên thành công!", "Xóa giảng viên thành công!"));
          getAllLecturer();
        }
      });
    } catch (err) { }
  };

  // Import file Excel to add new
  const importExcel = async (file: any) => {
    setLoading(true);
    await importExcelMoocLecturer(file).then((res) => {
      if (res.status === 200) {
        message.success(t("Thêm mới giảng viên thành công!", "Thêm mới giảng viên thành công!"));
        setLoading(false);
        setTimeout(() => {
          setLoading(false);
        }, 300);
        getAllLecturer();
      }
    }).catch((err) => {
      {
        setLoading(false);
        console.error(err);
      }
    })
  }

  // Import IndustryDB
  const handleCloseImportLecturerModal = () => {
    setOpenImportLecturerModal(false);
  }

  // Export file Excel
  const exportExcel = async () => {
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue.trim(),
      universityId: filterData.university,
      positionId: filterData.regency,
      createdFromDate: filterData.createdDateFrom ? filterData.createdDateFrom : null,
      createdToDate: filterData.createdDateTo ? filterData.createdDateTo : null,
      sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? ['created_date, desc'] : [`${fieldSortOrder},${statusOrder}`],
      status: filterData.status,
    };
    setIsRendering(true);
    try {
      await exportExcelMoocLecturer(dataReq).then((res) => {
        const fileData = res.data;

        const blob = new Blob([fileData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);

        downloadLink.download = `${t("Danh sách giảng viên", "Danh sách giảng viên")}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        message.success(t("Tải xuống thành công!", "Tải xuống thành công!"));
        setIsRendering(false);
      })
    } catch (err) {
      setIsRendering(false);
      console.error("Error downloading Excel file:", err);
    }
  }

  // Download file template excel
  const handleDownloadFile = async () => {
    try {
      await downloadLecturerTemplateFile().then((res) => {
        const fileData = res.data;

        const blob = new Blob([fileData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);

        downloadLink.download = `${t("Mẫu thêm mới", "Mẫu thêm mới")} ${t("giảng viên", "giảng viên")}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        message.success(t("Tải xuống thành công!", "Tải xuống thành công!"))
      })
    } catch (err) {
      console.error("Error downloading Excel file:", err);
    }
  }

  // Sort
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
          ? "desc"
          : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  // useEffect
  useEffect(() => {
    if (Object.keys(dataDetail).length > 0) {
      const educationLevels = dataDetail.moocTeacherProfiles.map((item: any) => {
        return (item.id)
      })

      const positionIds = dataDetail.authPositions.map((item: any) => {
        return (item.id)
      })

      const industryIds = dataDetail.industryGroupInfo?.children.map((item: any) => {
        return (item.id)
      })
      
      form.setFieldsValue({
        name: dataDetail.name,
        university: dataDetail.universityId,
        gender: dataDetail.gender,
        code: dataDetail.code,
        domicile: dataDetail.provinceCode ? dataDetail.provinceCode : null,
        regency: positionIds ? positionIds[0] : null,
        academicLevel: educationLevels ? educationLevels[0] : null,
        department: dataDetail.industryGroupInfo?.id ? dataDetail.industryGroupInfo?.id : null,
        specialized: industryIds ? industryIds : null,
        phone: dataDetail.phoneNumber,
        email: dataDetail.email,
        status: dataDetail.status,
      });
    }
  }, [dataDetail]);
  
  useEffect(() => {
    if(hasUniversity) {
      getAllLecturer();
    }
  }, [pageNumber, pageSize, filterData, statusOrder, hasUniversity, localStorage.schoolManagement]);
  
  useEffect(() => {
    if(hasUniversity) {
      getAllUniversity();
    }
  }, [localStorage.schoolManagement]);

  useEffect(() => {
    setLoading(true);
    Promise.all([getAcademicLevelLecturer(), getAllIndustryGroup(), getIndustryLecturer(''),
    getPositionsLecturer(), getAddressProvinces(), getAllEnterpriseUniversityVer2({})])
      .then((res) => {
        const dataAcademicLevel = res[0]?.data?.data?.map((item: any) => {
          return ({
            id: item.id,
            name: item.levelName,
          })
        })
        const dataIndustryGroup = res[1]?.data?.data;
        const dataIndustry = res[2]?.data?.data;
        const dataPositions = res[3]?.data?.data;
        const dataProvinces = res[4].data.data.map((item: any) => {
          return ({
            id: item.code,
            name: item.name,
          })
        });

        const dataEnterpriseUniversity = res[5].data?.data?.map((item: any) => {
          return ({
            id: item.universityId,
            name: item.name,
            uuid: item.uuid,
          })
        });

        setDataOptions({
          ...dataOptions,
          dataAcademicLevel: dataAcademicLevel,
          dataDepartment: dataIndustryGroup,
          dataSpecialized: dataIndustry,
          dataRegency: dataPositions,
          dataProvinces: dataProvinces,
          dataUniversity: dataEnterpriseUniversity,
        })

        setTimeout(() => {
          setHasUniversity(true);
          setLoading(false);
        }, 300);
      })
  }, [reload]);

  return (
    <Layout className="page-header-group">
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name === "createLecturer") {
            const { createLecturer } = forms;
            const data = createLecturer.getFieldsValue(validateFieldCreate);
            onFinishCreate(data);
          }
        }}
      >
        <div className={`page-header-group--layout ${showFilter ? "open-filter" : ""}`} >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title} listBreadcrumb={listBreadcrumb} />
            </div>
            <FilterTable
              handleOpen={handleOpenCreate}
              searchValue={searchValue}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              handleChangeInput={handleChangeInput}
              exportExcel={exportExcel}
              handleDownloadFile={handleDownloadFile}
              importExcel={importExcel}
              isRendering={isRendering}
              setOpenImportLecturerModal={setOpenImportLecturerModal}
            />
          </div>
          <FormFilter
            clearFilter={clearFilter}
            dataOptions={dataOptions}
            onFinish={handleFinish}
            showFilter={showFilter}
            check={check}
          />
        </div> 

        <TableData
          dataTable={dataLecturer}
          dataColumns={dataColumns}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          pagination={true}
          scroll={{ x: 1500, y: 600 }}
          totalRecords={totalRecords}
          loadingTable={loading}
          handleTableChangeProps={handleTableChange}
        />

        <DrawerCustom title={isOpenedEdit ? t("Chỉnh sửa giảng viên", "Chỉnh sửa giảng viên") : t("Thêm mới giảng viên", "Thêm mới giảng viên")}
          open={isOpened}
          onClose={handleClose}
          extraNode={
            <Space>
              <Button onClick={handleClose} className="btn btn-outlined">
                <CloseOutlined />
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
              <Button className="btn btn-primary" htmlType="submit" onClick={handleCreateAndEdit} disabled={isSaving}>
                {isSaving ? <LoadingOutlined /> : <SaveOutlined />}
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
            </Space>
          }
          widthDrawer={690}
        >
          <FormCreateLecturer form={form} dataOptions={dataOptions} loadingForm={loadingForm} />
        </DrawerCustom>
      </Form.Provider>
      <ImportIndustryDBModal openImportLecturerModal={openImportLecturerModal} handleCloseImportLecturerModal={handleCloseImportLecturerModal}/>
    </Layout>
  );
};

export default LecturerManagement;



